import { NewsPage } from "../../news/pages/NewsPage"
import { Page } from "../../../shared/components/pageHeader/PageHeaderApi"
import { LocalizedStrict } from "../../localization/components/AppLocalized"
import { PageHeader } from "../../../shared/components/pageHeader/PageHeader"

export function UserNews() {
    return (
        <>
            <LocalizedStrict id="user-home-top-bar-news-title" attrs={{ title: true }}>
                <PageHeader page={Page.USER_NEWS} title="About Facilitynet" />
            </LocalizedStrict>
            <NewsPage />
        </>
    )
}
